// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Canvas slide-over Discovery Catalog drawer: what is specific to this drawer.
 *
 * The panel itself is the shared
 * ../../packages/publishing/CatalogDrawerShell.module.css, as for the Node,
 * Data and Model drawers; header and search row are the shared
 * packages/publishing components.
 */

/* The Data drawer's tier: like it, this drawer opens a details modal on top of
   itself, and the two are never open together. */
.PisPRHRSgXZIkNpT5Vjq {
  --curio-drawer-z: var(--curio-z-dataset-drawer);
}

/* A source's body, as the page lays it out, inside the drawer's scroll body. */
.qqXD1WEDSOI5nWgxasGP {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* The page's banner, without the page's side margins. */
.xd2p5MkHOJkncJXvXpFT {
  margin: 0 0 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/discovery/catalog/DiscoveryCatalogDrawer.module.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF;iDACiD;AACjD;EACE,+CAA+C;AACjD;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wDAAwD;AACxD;EACE,gBAAgB;AAClB","sourcesContent":["/*\n * Canvas slide-over Discovery Catalog drawer: what is specific to this drawer.\n *\n * The panel itself is the shared\n * ../../packages/publishing/CatalogDrawerShell.module.css, as for the Node,\n * Data and Model drawers; header and search row are the shared\n * packages/publishing components.\n */\n\n/* The Data drawer's tier: like it, this drawer opens a details modal on top of\n   itself, and the two are never open together. */\n.overlayRoot {\n  --curio-drawer-z: var(--curio-z-dataset-drawer);\n}\n\n/* A source's body, as the page lays it out, inside the drawer's scroll body. */\n.sourceBody {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* The page's banner, without the page's side margins. */\n.banner {\n  margin: 0 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlayRoot": `PisPRHRSgXZIkNpT5Vjq`,
	"sourceBody": `qqXD1WEDSOI5nWgxasGP`,
	"banner": `xd2p5MkHOJkncJXvXpFT`
};
export default ___CSS_LOADER_EXPORT___;
